// extracted by mini-css-extract-plugin
export default {"option-wrapper":"styles_option-wrapper__+snTH"};